export default {
	setMissionVision(state, vision_mission) {
		state.vision_mission = vision_mission
	},
}
